import { BehaviorSubject, Subject } from 'rxjs';

import { popDevTools } from './pop-devtools';
import type { PopDevToolsChannel, PopDevToolsEvent } from './types';

export interface PopDevToolsNavigationRequest {
  id: number;
  channel?: PopDevToolsChannel;
  eventId?: number;
  clearQuery?: boolean;
}

let nextNavigationRequestId = 1;

const navigationRequestSubject = new BehaviorSubject<PopDevToolsNavigationRequest | undefined>(undefined);
const openedSubject = new Subject<number>();

export const popDevToolsNavigationRequests$ = navigationRequestSubject.asObservable();
export const popDevToolsOpened$ = openedSubject.asObservable();

export const notifyPopDevToolsOpened = () => {
  openedSubject.next(Date.now());
};

const requestPopDevToolsNavigation = (request: Omit<PopDevToolsNavigationRequest, 'id'>) => {
  navigationRequestSubject.next({ ...request, id: nextNavigationRequestId++ });
};

const getLatestErrorEvent = (): PopDevToolsEvent | undefined => {
  const errors = popDevTools.getEvents({ channel: 'errors' });
  return errors[errors.length - 1];
};

export const openPopDevToolsToLatestError = () => {
  const latestError = getLatestErrorEvent();
  requestPopDevToolsNavigation({
    channel: 'errors',
    eventId: latestError?.id,
    clearQuery: true,
  });
  popDevTools.open();
};
